import { SideDataChartComponent } from '../charts/side-data-chart-component'

//TODO: rename class to AFMetricsChartComponent
export class AFTwitterMetricsData extends SideDataChartComponent {
 static config = {
  selector: 'afTwitterMetricsChart',
  controller: AFTwitterMetricsData,
  bindings: SideDataChartComponent.config.bindings,
  template: SideDataChartComponent.config.template,
 }
}
